<template>
  <div class="order-list">
    <van-nav-bar title="订单" left-text="返回" left-arrow @click-left="$router.push('/user')" >
      <template #right>
        <van-dropdown-menu active-color="#1989fa" >
          <van-dropdown-item v-model="orderType" :options="orderTypeOption" @change="filterOrder"/>
        </van-dropdown-menu>
      </template>
    </van-nav-bar>
    <van-tabs v-model="active" @click="pushRefresh">
      <van-tab><template #title>所有<font color="red">({{orderCounts[0]}})</font></template></van-tab>
      <van-tab><template #title>当月 <font color="red">({{orderCounts[1]}})</font></template></van-tab>
      <van-tab><template #title>昨日 <font color="red">({{orderCounts[2]}})</font></template></van-tab>
      <van-tab><template #title>今日 <font color="red">({{orderCounts[3]}})</font></template></van-tab>
    </van-tabs>

    <div style="margin-top:10px">
      <van-pull-refresh v-model="refreshing" @refresh="pushRefresh">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="getOrder">
          <van-collapse v-model="activeNames" v-for="item in orderList"
                        :key="item.id">
            <van-collapse-item :name="item.id" v-if="orderType == 'movie'">
              <template #title>
                <div><van-icon name="question-o" />{{item.filmName}} ({{item.cinemaName}}) </div>
                <van-tag :type="filmOrderTag(item.status)">{{filmOrderStatus(item.status)}}</van-tag>
                <van-cell :title="`观影时间:`+item.showTime" :value="`影厅:`+item.hallName+`  `+item.seatsDesc"
                          title-class="custom-title" value-class="custom-value"
                />
              </template>
              <van-cell-group v-for="coupon in item.couponList"
                              :key="coupon.id">
                <van-cell :title="`取票码:`+coupon.couponCode"  title-class="custom-title"/>
                <van-image
                        width="300px"
                        height="300px"
                        fit="contain"
                        :src="coupon.couponCodeImageUrl"
                />
              </van-cell-group>
            </van-collapse-item>
          </van-collapse>
        </van-list>
      </van-pull-refresh>
      <no-data v-if="orderList.length == 0 && !loading"></no-data>
    </div>
  </div>
</template>


<script>
    import { Icon, Cell, CellGroup, NavBar, Button, Card, Tag ,Tab, Tabs, Panel, PullRefresh,DropdownMenu,DropdownItem, Collapse, CollapseItem, Image} from "vant";
    import NoData from "@/components/NoData";
    import fetch from '../../libs/fetch'
    import {Dialog} from 'vant'
    export default {
        components: {
            [NavBar.name]: NavBar,
            [Icon.name]: Icon,
            [Cell.name]: Cell,
            [CellGroup.name]: CellGroup,
            [Button.name]: Button,
            [Card.name]: Card,
            [Tag.name]: Tag,
            [Tab.name]: Tab,
            [Tabs.name]: Tabs,
            [Panel.name]: Panel,
            [PullRefresh.name]: PullRefresh,
            [DropdownMenu.name]: DropdownMenu,
            [DropdownItem.name]: DropdownItem,
            [Collapse.name]: Collapse,
            [CollapseItem.name]: CollapseItem,
            [Image.name]: Image,

            NoData
        },
        data() {
            return {
                loading: false,
                finished: false,
                refreshing: false,
                orderList: [],
                page: {
                    pageNum: 1,
                    pageSize: 20
                },
                active: 3,
                orderCounts: [0,0,0,0],

                orderType: 'movie',
                orderTypeOption: [
                    { text: '电影票', value: 'movie' },
                ],

                activeNames: ['1'],
            };
        },
        mounted() {},
        computed: {},
        methods: {
            pushRefresh() {
                this.loading = true
                this.orderList = []
                this.page.pageNum = 1
                this.getOrder()
                this.finished = false
            },
            getOrderCounts() {
                for (var i=0;i<4;i++){
                    this.getOrderCount(i)
                }
            },
            getOrderCount(periodType) {
                // 获取订单
                const openId = localStorage.getItem('openId')
                let url = '/pdd-order/public/mtorder?openId=' + openId+"&periodType="+periodType+"&pageSize="+this.page.pageSize+"&pageNum=1";
                if(this.orderType == 'movie'){
                    url = '/pdd-order/public/qzorder?openId=' + openId+"&periodType="+periodType+"&pageSize="+this.page.pageSize+"&pageNum=1";
                }
                fetch({
                    url: url,
                    method: 'get'
                }).then(response => {
                    this.orderCounts[periodType] = response.data.total
                }).catch(error => {
                    console.log(error)
                    Dialog.alert({
                        title: '系统提示',
                        message: error
                    }).then(() => {
                        // on close
                    })
                });
            },
            getOrder() {
                this.getOrderCounts()
                // 获取订单
                const openId = localStorage.getItem('openId')
                let url = '/pdd-order/public/mtorder?openId=' + openId+"&periodType="+this.active+"&pageSize="+this.page.pageSize+"&pageNum="+this.page.pageNum;
                if(this.orderType == 'movie'){
                    url = '/pdd-order/public/qzorder?openId=' + openId+"&periodType="+this.active+"&pageSize="+this.page.pageSize+"&pageNum="+this.page.pageNum;
                }
                fetch({
                    url: url,
                    method: 'get'
                }).then(response => {
                    let totalPage = Math.floor(response.data.total/this.page.pageSize) + 1
                    if(totalPage == this.page.pageNum){
                        this.finished = true
                    } else {
                        this.page.pageNum++
                    }
                    this.orderList = this.orderList.concat(response.data.list);
                    this.loading = false
                    this.refreshing = false
                }).catch(error => {
                    console.log(error)
                    Dialog.alert({
                        title: '系统提示',
                        message: error
                    }).then(() => {
                        // on close
                    })
                    this.loading = false
                    this.refreshing = false
                });
            },
            getDate(date_str) {
                return date_str.split(".")[0];
            },
            formatPrice(money) {
                if (money) {
                    let _money = Math.ceil(Number(money)) / 100;
                    return _money;
                } else {
                    return 0;
                }
            },
            commissionType(type){
                if(type == 0){
                    return '团长'
                }else if(type == 1){
                    return 'A级'
                }else if(type == 2){
                    return 'B级'
                }else if(type == 3){
                    return 'C级'
                }

            },

            filmOrderStatus(type){
                if(type == 0){
                    return '待付款'
                }else if(type == 5){
                    return '待出票'
                }else if(type == 10){
                    return '已出票'
                }else if(type == 15){
                    return '交易成功'
                }else if(type == -5){
                    return '已取消'
                }

            },
            filmOrderTag(type){
                if(type == 0){
                    return 'primary'
                }else if(type == 5){
                    return 'warning'
                }else if(type == 10){
                    return 'success'
                }else if(type == 15){
                    return 'success'
                }else if(type == -5){
                    return 'danger'
                }

            },
            filterOrder(){
                this.pushRefresh()
            }
        },
        filters: {
            // formatPrice(money) {
            //   return money.toFix(2)
            // }
        }
    };
</script>

<style lang="less">
  .order-list {
    z-index: 1000;
    padding-bottom: 55px;
    background-color: #f8f8f8;
    p {
      margin: 0;
    }
  }
  .custom-title {
    font-size: 12px;
  }
  .custom-value{
    font-size: 10px;
  }
  .van-dropdown-menu__bar{
    box-shadow: none;
  }
  .van-tabs__line{
    z-index: 0;
  }
  .van-cell{
    padding-top: 5px;
    padding-bottom: 5px;

  }
</style>
